import { removeNotification } from '../../store/general/slice';
import styles from './style.module.scss';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { ToastInterface, ToastStatus } from '../../store/general/types';

const warningIcon = require('../../assets/icons/warning.svg').default;
const checkIcon = require('../../assets/icons/success.svg').default;
const errorIcon = require('../../assets/icons/error.svg').default;
const infoIcon = require('../../assets/icons/info.svg').default;

interface Props {
    toastList: ToastInterface[];
    autoDelete: boolean;
    dismissTime: number;
};

const Toast = (props: Props) => {
    const { toastList, autoDelete, dismissTime } = props;
    const dispatch = useDispatch();

    useEffect(() => {
        const interval = setInterval(() => {
            if (autoDelete && toastList.length) {
                dispatch(removeNotification());
            }
        }, dismissTime);

        return () => {
            clearInterval(interval);
        }

    }, [toastList]);

    const toastIcon = (status: ToastStatus) => {
        const icons = {
            success: checkIcon,
            warning: warningIcon,
            error: errorIcon,
            info: infoIcon
        };

        return icons[status];
    };

    return (
        <>
            <div className={`${styles.notification_container} ${styles.bottom_left}`}>
                {toastList.map((toast, i) => {
                    return (<div
                        key={i}
                        className={`${styles.notification} ${styles.toast} ${styles.bottom_left}`}
                        data-notif-status={toast.status}
                    >
                        <div className={styles.notification_image}>
                            <img src={toastIcon(toast.status)} />
                        </div>
                        <div>
                            <p className={styles.notification_message}>
                                {toast.message}
                            </p>
                        </div>
                    </div>)
                })}
            </div>
        </>
    );
}

export default Toast;
